import React from 'react';
import s from './SSL.scss';

export const SSL = () => {
  return <div className={s.ssl} />;
};
